"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeGridTemplateShorthand = exports.openGridTemplateShorthand = exports.openGridTemplateShorthandSyntax = exports.getGridTemplateShorthandParts = void 0;
var tslib_1 = require("tslib");
var tokenizers_1 = require("../../tokenizers");
var shorthands_ast_evaluation_1 = require("../shorthands-ast-evaluation");
var shorthand_css_data_1 = require("../shorthand-css-data");
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var shorthand_parser_errors_1 = require("../shorthand-parser-errors");
var getGridTemplateShorthandParts = function () {
    return [
        { prop: 'grid-template-areas', dataType: css_data_types_1.gridTemplateAreasDataType, multipleItems: true },
        { prop: 'grid-template-rows', dataType: css_data_types_1.gridTemplateRowsDataType, multipleItems: true },
        { prop: 'grid-template-columns', dataType: css_data_types_1.gridTemplateColumnsDataType, multipleItems: true },
    ];
};
exports.getGridTemplateShorthandParts = getGridTemplateShorthandParts;
var openGridTemplateShorthandColumns = function (opened, astNodes, prevMatchLength, explicit) {
    if (explicit === void 0) { explicit = false; }
    var columnsMatch = (0, shorthand_parser_utils_1.matchDataType)(!explicit ? css_data_types_1.gridTemplateColumnsDataType : css_data_types_1.explicitTrackListDataType, astNodes, prevMatchLength, css_data_types_1.gridTemplateRowsDataType.dataType);
    if (!columnsMatch || Number(columnsMatch) !== astNodes.length - prevMatchLength) {
        throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('grid-template', 'grid-template-columns');
    }
    opened['grid-template-columns'] = astNodes.slice(prevMatchLength + 1, prevMatchLength + Number(columnsMatch));
    return opened;
};
var openGridTemplateShorthandRowsColumnsSyntax = function (astNodes, rowsLength) {
    if (astNodes.length === rowsLength) {
        throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('grid-template', 'grid-template-columns');
    }
    var opened = {
        'grid-template-rows': astNodes.slice(0, rowsLength),
    };
    return openGridTemplateShorthandColumns(opened, astNodes, rowsLength);
};
var openGridTemplateShorthandAreasSyntax = function (astNodes, trackList) {
    var opened = {
        'grid-template-areas': (0, shorthands_ast_evaluation_1.codeToEvaluatedAst)((0, tokenizers_1.createCssValueAST)((0, css_data_types_1.getTrackListAreasText)(trackList))),
        'grid-template-rows': (0, shorthands_ast_evaluation_1.codeToEvaluatedAst)((0, tokenizers_1.createCssValueAST)((0, css_data_types_1.getTrackListRowsText)(trackList))),
    };
    var trackListLength = Number(trackList.match);
    return astNodes.length > trackListLength
        ? openGridTemplateShorthandColumns(opened, astNodes, trackListLength, true)
        : opened;
};
var openGridTemplateShorthandSyntax = function () {
    return function (astNodes) {
        var rowsMatch = (0, shorthand_parser_utils_1.matchDataType)(css_data_types_1.gridTemplateRowsDataType, astNodes, 0);
        if (rowsMatch) {
            return openGridTemplateShorthandRowsColumnsSyntax(astNodes, Number(rowsMatch));
        }
        else {
            var trackList = (0, css_data_types_1.parseTrackListWithStrings)(astNodes[0].value, 0, astNodes);
            if (!trackList.match) {
                throw new shorthand_parser_errors_1.NoMandatoryPartMatchError('grid-template', 'grid-template-rows');
            }
            return openGridTemplateShorthandAreasSyntax(astNodes, trackList);
        }
    };
};
exports.openGridTemplateShorthandSyntax = openGridTemplateShorthandSyntax;
// grid-template
var openGridTemplateShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'grid-template',
        singleKeywordPart: {
            prop: 'grid-template',
            dataType: css_data_types_1.gridTemplateSingleValueDataType,
            partOpener: (0, shorthand_parser_utils_1.singleKeywordShorthandOpener)(shorthand_css_data_1.GRID_TEMPLATE_KEYWORD_VALUE_MAP, true),
        },
        parts: (0, exports.getGridTemplateShorthandParts)(),
        shorthandOpener: (0, exports.openGridTemplateShorthandSyntax)(),
    });
};
exports.openGridTemplateShorthand = openGridTemplateShorthand;
var closeGridTemplateShorthandRowsColumnsSyntax = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.shorthandCloserTemplate)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["", " / ", ""], ["", " / ", ""])), 'grid-template-rows', 'grid-template-columns'));
};
var closeGridTemplateShorthandAreasSyntax = function () {
    return function (opened, api, detachExpression) {
        var openedAreas = opened['grid-template-areas'];
        var openedRows = opened['grid-template-rows'];
        var areasList = tslib_1.__spreadArray([], tslib_1.__read(openedAreas), false);
        var splicedAreasRows = openedRows.reduce(function (splicedAreasRows, value) {
            var valueList = [value];
            if ((0, css_data_types_1.trackSizePredicate)(value.value)) {
                var currArea = areasList.shift();
                if (!currArea) {
                    throw new shorthand_parser_errors_1.CannotCloseGridTemplateError();
                }
                valueList.unshift(currArea);
            }
            return splicedAreasRows.concat(valueList);
        }, []);
        if (areasList.length > 0) {
            throw new shorthand_parser_errors_1.CannotCloseGridTemplateError();
        }
        return (0, shorthand_parser_utils_1.getOpenedNode)(splicedAreasRows, api, detachExpression);
    };
};
var closeGridTemplateShorthand = function () {
    return function (opened, api, detachExpression) {
        if ((0, shorthand_parser_utils_1.isOpenedInitial)(opened, 'grid-template-areas', css_data_types_1.gridTemplateAreasDataType)) {
            return closeGridTemplateShorthandRowsColumnsSyntax()(opened, api, detachExpression);
        }
        var closedAst = closeGridTemplateShorthandAreasSyntax()(opened, api, detachExpression);
        return (0, shorthand_parser_utils_1.fixAstNodesPositions)(closedAst
            .concat(tslib_1.__assign(tslib_1.__assign({}, (0, tokenizers_1.valueTextNode)('/')), { type: '/' }))
            .concat((0, shorthand_parser_utils_1.getOpenedNode)(opened['grid-template-columns'], api, detachExpression)), api);
    };
};
exports.closeGridTemplateShorthand = closeGridTemplateShorthand;
var templateObject_1;
//# sourceMappingURL=grid-template-shorthand.js.map